import { render, staticRenderFns } from "./Totaluser.vue?vue&type=template&id=6756d04c&scoped=true"
import script from "./Totaluser.vue?vue&type=script&lang=ts"
export * from "./Totaluser.vue?vue&type=script&lang=ts"
import style0 from "./Totaluser.vue?vue&type=style&index=0&id=6756d04c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6756d04c",
  null
  
)

export default component.exports